/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_JoiningInputs */

const zh_learn_joining = /** @type {(inputs: Learn_JoiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入中...`)
};

const en_learn_joining = /** @type {(inputs: Learn_JoiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joining...`)
};

const es_learn_joining = /** @type {(inputs: Learn_JoiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniendo...`)
};

/**
* | output |
* | --- |
* | "Joining..." |
*
* @param {Learn_JoiningInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_joining = /** @type {((inputs?: Learn_JoiningInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_JoiningInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_joining(inputs)
	if (locale === "en") return en_learn_joining(inputs)
	return es_learn_joining(inputs)
});